import ModalSelect from '../ModalSelect/ModalSelect'
import ModalManySelect from '../ModalManySelect/ModalManySelect'
import MobiSelectStates from '../MobiSelectStates/MobiSelectStates'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { get, isEmpty, keyBy } from 'lodash'

const renderServicePointSelect = ({ translate, item }) => {
    const options = []

    StoreCheckout.CheckOutInstance()
        .Instance()
        .ServicePointList()
        .forEach(servicePoint => options.push(servicePoint.value))

    if (!item.value) item.value = ''

    const label = translate(item.key)

    return (
        <ModalSelect
            label={label}
            onSet={value => {
                StoreCheckout.SetCheckoutFormValue(item.key, value)
            }}
            options={options}
            value={item.value.toUpperCase()}
            placeholder={translate(get(item, 'placeholder', '') || '')}
        />
    )
}

const renderProvinceManySelect = ({ translate, item, pickupShippingFormDetail }) => (
    <ModalManySelect
        item={item}
        label={pickupShippingFormDetail ? translate(pickupShippingFormDetail.label) : translate(item.key)}
    />
)

const renderMobiSelectStates = ({ translate, item, forceType, allItems, pickupShippingFormDetail }) => (
    <MobiSelectStates
        item={item}
        label={pickupShippingFormDetail ? translate(pickupShippingFormDetail.label) : translate(item.key)}
        forceType={forceType}
        allItems={allItems}
    />
)

const renderStandardSelect = context => {
    const { translate, item, pickupShippingFormDetail, forceType, allItems } = context

    const options = []

    StoreCheckout.CheckOutInstance()
        .Instance()
        .AddressOptionList(item.key, StoreCheckout)
        .forEach(option => options.push(option.value))

    if (!item.value) {
        item.value = ''
    }

    const label = pickupShippingFormDetail ? translate(pickupShippingFormDetail.label) : translate(item.key)
    const placeholder = translate(get(item, 'placeholder', '') || get(pickupShippingFormDetail, 'placeholder', ''))

    return (
        <ModalSelect
            label={label}
            onSet={value => {
                StoreCheckout.SetCheckoutFormValue(item.key, value)

                const isChainAddress = get(StoreCheckout.CheckOutInstance().Instance(), 'chainAddress.isChainAddress')
                const groupAddress = get(StoreCheckout.CheckOutInstance().Instance(), 'chainAddress.groupAddress', []) || []

                if (isChainAddress && groupAddress.includes(item.key)) {
                    const keyedItems = keyBy(allItems, 'key')

                    const newGroupAddress = groupAddress.reduce((result, key) => {
                        if (forceType === 'select' || isEmpty(allItems)) return [...result, key]
                        const currentItem = keyedItems[key]
                        if (currentItem?.type === 'select') {
                            return [...result, key]
                        }
                        return result
                    }, [])

                    const keysToReset = newGroupAddress.slice(newGroupAddress.indexOf(item.key) + 1) || []
                    keysToReset.forEach(key => StoreCheckout.SetCheckoutFormValue(key, ''))
                }
            }}
            disabled={isEmpty(options)}
            options={options}
            value={item.value}
            keys={item.key}
            placeholder={placeholder}
        />
    )
}

const renderSelectField = context => {
    const { item } = context

    if (item.key === 'service_point') {
        return renderServicePointSelect(context)
    }

    if (StoreCountry.Country3() === 'PHL' && item.key === 'province_selection') {
        return renderProvinceManySelect(context)
    }

    if (
        (['SAU'].includes(StoreCountry.Country3()) && item.key === 'city_selection') ||
        (['KWT'].includes(StoreCountry.Country3()) && item.key === 'area_selection') ||
        (item.key === 'district_selection' && context.allItems.length > 0)
    ) {
        return renderMobiSelectStates(context)
    }

    return renderStandardSelect(context)
}

export default renderSelectField

